import { RegistrationDtoInUrgencyEnum } from '../../generated';
import { Urgency } from '../../model/enums/Urgency';

export const fromUrgencyToGenerated = (data: Urgency): RegistrationDtoInUrgencyEnum => {
  switch (data) {
    case Urgency.Urgent:
      return RegistrationDtoInUrgencyEnum.Urgent;
    case Urgency.Normal:
      return RegistrationDtoInUrgencyEnum.Normal;
  }
}
